import { AuthService } from './services'
import { LoginPage } from './components'

export { AuthContext } from './contexts'

export const Login = AuthService(LoginPage)
